import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import constants from "constants";
import {
  normalizeHolidays,
  formatDay,
} from "services/bankHolidays";

const { API_ADMIN_BANK_HOLIDAYS } = constants;

const emptyForm = { name: "", holiday_date: "", end_date: "" };

const errorText = (e) => {
  const data = e && e.response && e.response.data;
  const messages = data && data.error_messages;
  if (messages) {
    return Object.keys(messages)
      .map((field) => `${field.replace(/_/g, " ")} ${messages[field][0]}`)
      .join("; ");
  }
  return "Oops, something went wrong...";
};

class BlockedDates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      holidays: [],
      page: 1,
      totalPages: 1,
      form: { ...emptyForm },
      errors: {},
      saving: false,
    };
  }

  componentDidMount() {
    this.load(1);
  }

  load = (page) => {
    axios
      .get(API_ADMIN_BANK_HOLIDAYS, { params: { page, per_page: 50 } })
      .then((response) => {
        const { bank_holidays, pages } = response.data;
        this.setState({
          holidays: normalizeHolidays(bank_holidays),
          page,
          totalPages: pages || 1,
        });
      })
      .catch(() => toast.error("Could not load blocked dates"));
  };

  onFieldChange = (e) => {
    this.setState({
      form: { ...this.state.form, [e.target.name]: e.target.value },
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { form } = this.state;
    const errors = {};
    if (!form.name.trim()) errors.name = "can't be blank";
    if (!form.holiday_date) errors.holiday_date = "can't be blank";
    if (form.end_date && form.holiday_date && form.end_date < form.holiday_date)
      errors.end_date = "must be on or after the From date";
    if (Object.keys(errors).length) {
      this.setState({ errors });
      return;
    }
    this.setState({ saving: true, errors: {} });
    axios
      .post(API_ADMIN_BANK_HOLIDAYS, {
        bank_holiday: {
          name: form.name.trim(),
          holiday_date: form.holiday_date,
          end_date: form.end_date || null,
        },
      })
      .then(() => {
        toast.success("Blocked dates added");
        this.setState({ form: { ...emptyForm }, saving: false });
        this.load(this.state.page);
      })
      .catch((err) => {
        const messages =
          (err.response &&
            err.response.data &&
            err.response.data.error_messages) ||
          {};
        const errors = {};
        Object.keys(messages).forEach((field) => {
          errors[field] = messages[field][0];
        });
        this.setState({ errors, saving: false });
        toast.error(errorText(err));
      });
  };

  onDelete = (holiday) => {
    if (
      !window.confirm(
        `Delete "${holiday.name}" (${formatDay(holiday.from)} - ${formatDay(
          holiday.to
        )})? These dates will become bookable again.`
      )
    )
      return;
    axios
      .delete(`${API_ADMIN_BANK_HOLIDAYS}/${holiday.id}`)
      .then(() => {
        toast.success("Blocked dates deleted");
        this.load(this.state.page);
      })
      .catch((err) => toast.error(errorText(err)));
  };

  renderError(field) {
    const message = this.state.errors[field];
    return message ? (
      <span style={{ color: "#f44336", fontSize: 12 }}>{message}</span>
    ) : null;
  }

  render() {
    const { holidays, form, page, totalPages, saving } = this.state;
    return (
      <main className="site--width clearfix container_statistics">
        <h3>Blocked dates</h3>
        <p>
          Nothing can be booked on the calendar during these dates. Leave "To"
          empty to block a single day.
        </p>
        <form onSubmit={this.onSubmit} style={{ marginBottom: 30 }}>
          <div className="row">
            <div className="col s12 m4">
              <label>Name</label>
              <input
                type="text"
                className="browser-default"
                name="name"
                value={form.name}
                onChange={this.onFieldChange}
                maxLength={255}
                style={{ width: "100%" }}
              />
              {this.renderError("name")}
            </div>
            <div className="col s12 m3">
              <label>From</label>
              <input
                type="date"
                className="browser-default"
                name="holiday_date"
                value={form.holiday_date}
                onChange={this.onFieldChange}
                style={{ width: "100%" }}
              />
              {this.renderError("holiday_date")}
            </div>
            <div className="col s12 m3">
              <label>To (optional)</label>
              <input
                type="date"
                className="browser-default"
                name="end_date"
                value={form.end_date}
                min={form.holiday_date || undefined}
                onChange={this.onFieldChange}
                style={{ width: "100%" }}
              />
              {this.renderError("end_date")}
            </div>
            <div className="col s12 m2">
              <button
                className="button_classic"
                type="submit"
                disabled={saving}
                style={{ marginTop: 20 }}
              >
                Add
              </button>
            </div>
          </div>
        </form>
        <div className="admin_user_table admin_table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>From</th>
                <th>To</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {holidays.length === 0 ? (
                <tr>
                  <td colSpan="4">No blocked dates.</td>
                </tr>
              ) : (
                holidays.map((holiday) => (
                  <tr key={holiday.id}>
                    <td>{holiday.name}</td>
                    <td>{formatDay(holiday.from)}</td>
                    <td>{formatDay(holiday.to)}</td>
                    <td>
                      <a
                        href="javascript:void(0)"
                        onClick={() => this.onDelete(holiday)}
                      >
                        Delete
                      </a>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {totalPages > 1 ? (
            <div style={{ marginTop: 15 }}>
              <button
                className="button_classic"
                type="button"
                disabled={page <= 1}
                onClick={() => this.load(page - 1)}
              >
                Previous
              </button>{" "}
              Page {page} of {totalPages}{" "}
              <button
                className="button_classic"
                type="button"
                disabled={page >= totalPages}
                onClick={() => this.load(page + 1)}
              >
                Next
              </button>
            </div>
          ) : null}
        </div>
      </main>
    );
  }
}

export default BlockedDates;



// WEBPACK FOOTER //
// ./src/containers/Admin/BlockedDates/BlockedDates.jsx